export function shuffle<T>(list: T[]): T[] {
  if (!list.length) {
    return list;
  }

  let rSelection, temp;
  let i = list.length;
  while (--i) {
    rSelection = Math.floor(Math.random() * (i + 1));
    temp = list[i];
    list[i] = list[rSelection];
    list[rSelection] = temp;
  }
  return list;
}

export function removeShuffled<T>(list: T[]): T | undefined {
  let result, rSelection;

  if (list.length) {
    rSelection = (Math.random() * list.length) << 0;
    if (rSelection === list.length - 1) {
      return list.pop();
    }
    const temp = list.pop() as T;
    result = list[rSelection];
    list[rSelection] = temp;
    return result;
  }
}

export function* shuffleGenerator<T>(list: T[]) {
  if (!list.length) {
    return;
  }

  let rSelection, next;
  let i = list.length;
  while (--i) {
    rSelection = Math.floor(Math.random() * (i + 1));
    if (rSelection >= list.length) {
      console.log("hit it!");
    }
    next = list[rSelection];
    list[rSelection] = list[i];
    list[i] = next;
    yield next;
  }
  return;
}
